import { Analysis, PossibleRootCauseCategory } from '.';

export class ElectrolytesAnalysis extends Analysis{
    calculateInsights() {
        if (this.ba.sodium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9000);
        } else if (this.ba.sodium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9010);
        }

        if (this.ba.potassium.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9020);
        } else if (this.ba.potassium.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9030);
        }

        // Na/K ratio interpretation moved to StressAdrenalAnalysis (90000/90010).

        if (this.ba.chloride.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9040);
        } else if (this.ba.chloride.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9050);
        }

        if (this.ba.carbonDioxide.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9060);
        } else if (this.ba.carbonDioxide.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9070);
        }

        if (this.ba.anionGapWithoutK.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9080);
        } else if (
            this.ba.anionGapWithoutK.isOptimal() &&
            this.ba.carbonDioxide.isStricklyLessThanOptimal()
        ) {
            // 9090 is the normal-anion-gap (hyperchloremic) acidosis pattern:
            // bicarbonate is being lost while the gap itself stays normal. Its
            // causes (diarrhea, kidney dysfunction, low aldosterone, zinc) only
            // apply when acidosis is actually present, so CO2 below optimal is
            // required. Without that gate it fired on every optimal anion gap.
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9090);
        } else if (this.ba.anionGapWithoutK.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9100);
        }

        if (this.ba.anionGap.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9110);
        } else if (this.ba.anionGap.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_9120);
        }
    }
}